export const serialSupport = global.navigator && 'serial' in global.navigator;
